import { RootState } from "../../index";

export const getWarning = (state: RootState) => state.warning;
